<div (click)="window.innerWidth < mobileMaxWidth ? openRangeDatePickerDialog() : menuTrigger.openMenu()">
  <div #contentSlot>
    <ng-content></ng-content>
  </div>

  @if (!contentSlot.children.length) {
    <div
      class="w-full md:w-[244px] p-xs pl-sm rounded-sm bg-ui-bg md:hover:bg-ui-hover flex justify-between items-center cursor-pointer border border-ui-separator {{
        extraClasses
      }}"
    >
      <div class="flex-1 overflow-hidden pr-sm flex flex-col">
        <div class="text-sm leading-sm text-txt-secondary">
          {{ selectedPeriodType ? periodTypeToLabel[selectedPeriodType] : 'Select period' }}
        </div>
        <div class="text-base leading-base truncate">{{ formattedPeriodTime }}</div>
      </div>
      <div class="flex items-center justify-center p-base bg-primary rounded-sm text-contrast">
        <svg-icon key="calendar-light" class="!text-base"></svg-icon>
      </div>
    </div>
  }
</div>

<div
  [matMenuTriggerFor]="window.innerWidth >= mobileMaxWidth ? dateRangePickerMenu : null"
  #menuTrigger="matMenuTrigger"
  (menuOpened)="menuIsOpen = true"
  (menuClosed)="setSelectedDate(); menuIsOpen = false"
></div>

<mat-menu
  #dateRangePickerMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="mg-filter-menu"
>
  <div
    class="flex flex-col overflow-auto w-[436px]"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (menuIsOpen) {
      <mg-range-date-picker
        focusInput="start"
        [value]="selectedValue"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [hideAllPeriods]="hideAllPeriods"
        [hiddenPeriods]="hiddenPeriods"
        (valueChanged)="valueChanged.emit($event); menuTrigger.closeMenu()"
        (canceld)="menuTrigger.closeMenu()"
      ></mg-range-date-picker>
    }
  </div>
</mat-menu>
